import apiServices from 'config/apiServiceApiGateway'
import {
  PutawayHubItemType,
  PutawayHubParamsType,
} from 'features/SupplyOrder/pages/PutawayHub/@types'

export type PutawayHubPaginationType = {
  sort: string
  direction: string
  page_size: string
  page_index: string
}

export type GetPutawayHubResponseType = {
  data: PutawayHubItemType[]
  pagination: PutawayHubPaginationType
}

export const getPutawayHubListAPI = (params: PutawayHubParamsType) =>
  apiServices.Get<GetPutawayHubResponseType, true>({
    url: '/wims/internal/v1/supply-order-inbound-putaway-tasks/monitoring-web',
    params,
  })

export type PatchResetPutawayHubPayloadType = {
  id: number
  action: 'REVERT'
}

export const resetPutawayHubItemAPI = (id: number, payload: PatchResetPutawayHubPayloadType) =>
  apiServices.Patch<{ message: string }, true>({
    url: `/wims/internal/v1/supply-order-inbound-putaway-tasks/${id}`,
    data: payload,
  })
